import { inject } from '@angular/core';
import { NonNullableFormBuilder } from '@angular/forms';

import type {
  DefineFormData,
  DynamicFormConfig,
  UnwrapSignal,
} from '@core/ask-hr-dynamic-forms-types';
import type { InfoboxTemplateItem } from '@core/ask-hr-templates-types';
import { I18nService } from '@core/i18n-legacy';

export class InfoboxConfig implements DynamicFormConfig {
  private readonly formBuilder = inject(NonNullableFormBuilder);
  private readonly i18n = inject(I18nService);

  public readonly kind: InfoboxTemplateItem['type'] = 'infobox';
  public readonly defineConfig: DynamicFormConfig['defineConfig'] = {
    name: this.i18n.translate('tlc.ask_hr.form_template_create.configs.infobox'),
    icon: 'info',
  };

  public readonly components = {
    define: () =>
      import('@core/ask-hr-dynamic-forms-smart-ui').then(m => m.WysiwygInfoboxComponent),
    respond: () =>
      import('@core/ask-hr-dynamic-forms-smart-ui').then(m => m.RespondInfoboxComponent),
    present: () =>
      import('@core/ask-hr-dynamic-forms-smart-ui').then(m => m.TextPresenterComponent),
  };

  public readonly defineForm = (data?: DefineFormData) =>
    this.formBuilder.group({
      textJson: this.formBuilder.control(<object>data?.value?.textJson ?? ''),
    });

  public readonly respondConfig = (data: {
    textJson: object;
  }): UnwrapSignal<
    import('@core/ask-hr-dynamic-forms-smart-ui').RespondInfoboxComponent['respondConfig']
  > => data;

  public readonly respondForm = (): UnwrapSignal<
    import('@core/ask-hr-dynamic-forms-smart-ui').RespondInfoboxComponent['respondForm']
  > => this.formBuilder.group({});

  public readonly presentConfig = (
    data: InfoboxTemplateItem,
  ): UnwrapSignal<
    import('@core/ask-hr-dynamic-forms-smart-ui').TextPresenterComponent['config']
  > => ({
    heading: '',
    value: '',
    kind: {
      type: 'text',
      multiline: false,
    },
  });
}
